import { authSlice } from "src/features/auth/auth.slice";

import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";

/**
 * Utility to reset certain fields of a slice's state to its initial value when the organization changes.
 * @param builder - The ActionReducerMapBuilder from createSlice.
 * @param stateToReset - The state to reset.
 */

export function resetStateOnChangeOrganization<S>(
  builder: ActionReducerMapBuilder<S>,
  stateToReset: Partial<S>
) {
  builder.addCase(authSlice.actions.changeOrganization, (state) => {
    return {
      ...state,
      ...stateToReset,
    };
  });
}